/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bad_Orange_Deer_RelishInputs */

const fr_bad_orange_deer_relish = /** @type {(inputs: Bad_Orange_Deer_RelishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour retrouver le contenu de ton programme, il faut aller sur la page d'accueil du site et voir le cours disponible dans le "Workout of the Day". Si rien n'est affiché c'est qu'il n'y a pas de contenu disponible.`)
};

/**

* @param {Bad_Orange_Deer_RelishInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const bad_orange_deer_relish = /** @type {((inputs?: Bad_Orange_Deer_RelishInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bad_Orange_Deer_RelishInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_bad_orange_deer_relish(inputs)
});